import _has from 'lodash/has';
import _includes from 'lodash/includes';
import _replace from 'lodash/replace';
import _parseInt from 'lodash/parseInt';
import _forEach from 'lodash/forEach';
import url from 'url';

export default {
	/**
	 * @param fontFiles is an array of fonts file name with extension that should be preloaded
	 */
	createPreloadFontsLinks(staticPublicPath, fontFiles) {
		let links = '';
		// eslint-disable-next-line no-restricted-syntax
		for (const fontFile of fontFiles) {
			links += `<link rel="preload" href="${staticPublicPath}fonts/${fontFile}" as="font" type="font/woff2" crossOrigin="anonymous">`;
		}
		return links;
	},

	preloadFirstSlideImage(moduleData, imageServerUrl) {
		const modules = Object.keys(moduleData);
		let imagePath = '';
		let linkTag = '';

		// eslint-disable-next-line array-callback-return
		modules.filter((m) => {
			const mod = moduleData[m];

			if (_has(mod, 'module_data.content_section.cons_slideshow.slide_group')
				&& mod.module_data.content_section.cons_slideshow.slide_group[0].slide_img
				&& mod.module_data.content_section.cons_slideshow.slide_group[0].slide_img.path) {
				imagePath = `${imageServerUrl}${mod.module_data.content_section.cons_slideshow.slide_group[0].slide_img.path}?resize=375px:250px&output-quality=75`;
				linkTag = `<link rel="preload" fetchpriority="high" as="image" href="${imagePath}">`;
			}
		});
		return linkTag;
	},

	/**
	 * Creates the link preload tag to preload image in header of interactive articles
	 * Returns the link tag
	 * @param moduleData
	 * @return {string|*}
	 */
	getHeaderImagePath(module) {
		let mediaAsset = {};

		if (_has(module, 'module_data.content_section.cons_health_ref.media_asset')) {
			mediaAsset = module.module_data.content_section.cons_health_ref.media_asset;
		} else if (_has(module, 'module_data.content_section.cons_feature.media_asset')) {
			mediaAsset = module.module_data.content_section.cons_feature.media_asset;
		} else if (_has(module, 'module_data.content_section.cons_import_health_ref.media_asset')) {
			mediaAsset = module.module_data.content_section.cons_import_health_ref.media_asset;
		} else if (_has(module, 'module_data.content_section.cons_news.media_asset')) {
			mediaAsset = module.module_data.content_section.cons_news.media_asset;
		} else if (_has(module, 'module_data.content_section.cons_bio.media_asset')) {
			mediaAsset = module.module_data.content_section.cons_bio.media_asset;
		}
		return {
			path: (mediaAsset && mediaAsset.path) ? mediaAsset.path : '',
			resizeParam: (mediaAsset && mediaAsset.wbmd_c_ht) ? mediaAsset.wbmd_c_ht : '',
		};
	},

	getEnvironment(domain) {
		let ads = '1';
		let servicedomain = 'https://www.webmd.com';
		let servicedomainOld = '';
		let servicedomainNew = '';
		let env = '';
		let newCluster = false;
		let ssr = true;

		if (typeof window !== 'undefined') {
			const host = window.location.host.toLowerCase();
			ssr = false;

			if (host.indexOf('localhost') > -1) {
				env = 'dev';
				servicedomain = 'https://www.staging.webmd.com';
				ads = '1';
			} else if (host.indexOf('.feature') > -1 || host.indexOf('.devint') > -1) {
				env = 'dev';
				servicedomain = 'https://www.devint.webmd.com';
				ads = '1';
			} else if (host.indexOf('.qa') > -1) {
				env = 'dev';
				servicedomain = 'https://www.qa.webmd.com';
				ads = '1';
			} else if (host.indexOf('.preview') > -1) {
				env = 'dev';
				servicedomain = 'https://www.preview.webmd.com';
				ads = '1';
			} else if (host.indexOf('.staging') > -1) {
				servicedomain = 'https://www.staging.webmd.com';
				ads = '1';
			} else {
				servicedomain = 'https://www.webmd.com';
				ads = '0';
			}
		} else if (domain && domain !== '') {
			const host = domain.toLowerCase();
			ssr = true;

			if (!host.includes('k8s.')) {
				newCluster = true;
			}

			if (host.indexOf('localhost') > -1) {
				env = 'dev';
				ads = '1';
				servicedomainOld = 'https://www.staging.webmd.com';
				servicedomainNew = 'https://www.staging.webmd.com';
			} else if (host.indexOf('.feature') > -1 || host.indexOf('.devint') > -1) {
				env = 'dev';
				ads = '1';
				servicedomainOld = 'https://searchsvc-spiider-api.k8s.devint.webmd.com';
				servicedomainNew = 'https://searchsvc-spiider-api.ma1.devint.webmdhelios.com';
			} else if (host.indexOf('.qa') > -1) {
				env = 'dev';
				ads = '1';
				servicedomainOld = 'https://searchsvc-spiider-api.k8s.qa.webmd.com';
				servicedomainNew = 'https://searchsvc-spiider-api.ma1.qa.webmdhelios.com';
			} else if (host.indexOf('.preview') > -1) {
				env = 'dev';
				ads = '1';
				if (host.indexOf('.la1') > -1) {
					servicedomainOld = 'https://searchsvc-spiider-api.k8s.preview.la1.webmd.com';
					servicedomainNew = 'https://searchsvc-spiider-api.la1.preview.webmdhelios.com';
				} else {
					servicedomainOld = 'https://searchsvc-spiider-api.k8s.preview.webmd.com';
					servicedomainNew = 'https://searchsvc-spiider-api.ma1.preview.webmdhelios.com';
				}
			} else if (host.indexOf('.staging') > -1) {
				ads = '1';
				if (host.indexOf('.la1') > -1) {
					servicedomainOld = 'https://searchsvc-spiider-api.k8s.staging.la1.webmd.com';
					servicedomainNew = 'https://searchsvc-spiider-api.la1.staging.webmdhelios.com';
				} else {
					servicedomainOld = 'https://searchsvc-spiider-api.k8s.staging.webmd.com';
					servicedomainNew = 'https://searchsvc-spiider-api.ma1.staging.webmdhelios.com';
				}
			} else {
				ads = '0';
				if (host.indexOf('.la1') > -1) {
					servicedomainOld = 'https://searchsvc-spiider-api.k8s.la1.webmd.com';
					servicedomainNew = 'https://searchsvc-spiider-api.la1.webmdhelios.com';
				} else {
					servicedomainOld = 'https://searchsvc-spiider-api.k8s.webmd.com';
					servicedomainNew = 'https://searchsvc-spiider-api.ma1.webmdhelios.com';
				}
			}
		} else {
			ads = '0';
			servicedomain = 'https://www.webmd.com';
		}

		const result = {
			env,
			// eslint-disable-next-line no-nested-ternary
			servicedomain: !ssr ? servicedomain : newCluster ? servicedomainNew : servicedomainOld,
			ads,
		};

		return result;
	},

	getStaticData() {
		return {
			assets: {
				dictionary: [
					'091e9c5e80048db2',
				],
				biography: [
					'091e9c5e8000911f',
				],
				medref: [
					'091e9c5e8197ce75',
				],
			},
			mocks: [
				'091e9c5e80048db2',
				'091e9c5e8000911f',
				'091e9c5e8197ce75',
			],
			endpoints: {
				biography: 'newruntime_biographystatic',
				dictionary: 'newruntime_dictionarystatic',
				cms_articles: 'optimized_rt_cmsarticles',
				medref: 'newruntime_medrefstatic',
				default: 'optimized_rt_cms',
			},
		};
	},

	/**
	 * Will return the pagination start value
	 * Formula : (pageNumber - 1) * noOfRecords
	 * Ex : for Pagination, page-number 2, no-of-record to display as 10 : (2-1)*10 = 10
	 * @param pageNumber
	 * @param displayRecordsCount
	 * @returns startFrom
	 */
	getPaginationStartValue(pageNum, displayRecordsCount) {
		let startFrom = 0;
		const pageNumber = _parseInt(pageNum);
		const recordsToDisplay = _parseInt(displayRecordsCount);
		if (pageNumber > 0) {
			startFrom = (pageNumber - 1) * recordsToDisplay;
		}
		return startFrom;
	},

	/**
	 * Updating _filter_, _pagenum_ parameters in RSS
	 * Any 'filter' value in the main URL, will update that into RSS _filter_ value
	 * Any 'pg' param in the main URL, will update that into _pagenum_ value,
	 * if no 'pg'param then will set as Zero
	 * @param rssUrl
	 * @param route
	 * @param show_link_count
	 * @returns blogRssUrl
	 */
	getUpdatedRssUrl(rssUrl, route, showLinkCount) {
		let blogRssUrl = rssUrl;

		/* Default Values */
		const defaultFilterValue = '*';
		const defaultPageNumberValue = 1;

		/* Updating Filter param value */
		if (_includes(blogRssUrl, '_filter_')) {
			// eslint-disable-next-line no-mixed-operators
			const filterValue = route.query && route.query.filter || defaultFilterValue;
			blogRssUrl = _replace(blogRssUrl, '_filter_', filterValue);
		}

		/* Updating Page number value */
		if (_includes(blogRssUrl, '_pagenum_')) {
			// eslint-disable-next-line no-mixed-operators
			const pageNumberValue = route.query && route.query.pg || defaultPageNumberValue;
			const paginationStartValue = this.getPaginationStartValue(pageNumberValue, showLinkCount);
			blogRssUrl = _replace(blogRssUrl, '_pagenum_', paginationStartValue);
		}
		return blogRssUrl;
	},

	/**
	 * Add given tex value to tex value array and returns
	 * @param existingValue
	 * @param valueToAdd
	 * @returns {string} string of tex values
	 */
	addTexValue(existingValue, valueToAdd) {
		let tex = [];

		if (typeof existingValue === 'string') {
			tex = [existingValue];
		} else if (typeof existingValue === 'object' && existingValue.length !== undefined) {
			tex = existingValue;
		}

		tex.push(valueToAdd);

		return tex.join('_');
	},

	/**
	 * Send image url with max width or min width or device to create responsive preload tags
	 * @param images array of image uel and resolution
	 * @returns {string} string of link tags
	 */
	getPreloadedImg(images) {
		let responsiveLinkTags = '';
		_forEach(images, (responsiveUrl) => {
			const responsiveImg = responsiveUrl;
			let mediaText = '(min-width: 0)';
			switch (responsiveImg.device) {
				case 'desktop':
					responsiveImg.min = '992px';
					break;
				case 'tablet':
					responsiveImg.min = '768px';
					responsiveImg.max = '991.98px';
					break;
				case 'mobile':
					responsiveImg.max = '767.98px';
					break;
				default:
					break;
			}
			if (responsiveImg.min && responsiveImg.max) {
				mediaText = `(min-width: ${responsiveImg.min}) and (max-width: ${responsiveImg.max})`;
			} else if (responsiveImg.min && !responsiveImg.max) {
				mediaText = `(min-width: ${responsiveImg.min})`;
			} else if (!responsiveImg.min && responsiveImg.max) {
				mediaText = `(max-width: ${responsiveImg.max})`;
			}
			responsiveLinkTags += `<link rel="preload" fetchpriority="high" as="image" href="${responsiveUrl.url}" media="${mediaText}">`;
		});
		return responsiveLinkTags;
	},

	/**
	 * get original node api with environment
	 *
	 * Example: https://ec-blogs-api.nodeapihost.com/kapi/v1/get-recirc-articles?aboutness=*&articleid=091e9c5e81a2ae7e&rows=3
	 *
	 * Example Application Name: ec-blogs-api
	 *
	 * Retrun and Original URL: https://ec-blogs-api.k8s.qa.webmd.com/kapi/v1/get-recirc-articles?aboutness=*&articleid=091e9c5e81a2ae7e&rows=3
	 *
	 * @param {string} host
	 * @param {string} rssUrl
	 * @returns
	 */
	getNodeApiEnvironment(host, rssUrl) {
		const fullNodeHostname = url.parse(rssUrl, true).hostname;
		const nodeHostname = url.parse(_replace(rssUrl, '.nodeapihost.com', ''), true).hostname;
		const rssHostname = _replace(url.parse(this.getEnvironment(host).servicedomain).hostname, 'searchsvc-spiider-api', nodeHostname);
		return _replace(rssUrl, fullNodeHostname, rssHostname);
	},
};
